import React from 'react';
import { getBEMClasses } from '../../helpers/cssClassesHelper';
import APLogo from '../../components/common/APLogo/APLogo';
import './StandAloneLayout.css';
var layoutClasses = getBEMClasses('standalone-layout');
var StandAloneLayout = function StandAloneLayout(props) {
  return React.createElement('div', {
    className: layoutClasses('wrapper')
  }, React.createElement(APLogo, {
    customClass: layoutClasses('logo'),
    linkTo: '/'
  }), props.children);
};
export default StandAloneLayout;